import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import React, { useEffect,useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import Menubar from "./Menubar";
import Login from "./Auth/Login";
import LoaderBar from "./Loader/LoaderBar";
import LogSearch from "./DeveloperPage/LogSearch";
import Session from "./Pages/Session";
import { API_URL } from "./ConstVariable";
import axios from "axios";
import InitializeSession from "./InitializeSession";

function App() {
  const { isLoading, isAuthenticated, error, getAccessTokenSilently, user } =
    useAuth0();
  const [sessionValidated, setSessionValidated] = useState(false)
  console.log(user, "check the user..");
  const UserOiProfile = user?.oi_profile;

  if (isLoading) {
    return (
      <div
        className="col-md-12 col-lg-12 col-sm-12 text-center"
        style={{ marginTop: "50vh" }}
      >
        <LoaderBar />
      </div>
    );
  }
  if (error) {
    return <div>Oops... {error.message}</div>;
  }

     if (isAuthenticated && sessionValidated) {
    return (
      <div>
        {UserOiProfile?.toUpperCase() === "DEVELOPER" ? (
          <LogSearch />
        ) : (
          <Menubar />
        )}
      </div>
    )
    } else if(isAuthenticated && !sessionValidated){
        return <InitializeSession setSessionValidated={setSessionValidated}/>
    } else {
        return <Login />;
    }
}

export default App;
